import React, { useEffect, useState } from "react";
import { withRouter } from "react-router";
import classnames from "classnames";
import { connect } from "react-redux";

import * as actions from "../../../../store/actions";

import Row from "../../../../components/uiElements/grid/Row";
import Button from "../../../../components/formElements/button/Button";
import OnboardingIcon from "../../../../components/uiElements/icons/onboardingIcons/OnboardingIcon";
import { updateUserData } from "../../../../utils/localStorage";
import { getOnboardingPath } from "../../../../constants";
import SpinnerBorder from "../../../../components/uiElements/loadingSpinner/SpinnerBorder";

const DoseSpot = ({
  createClinicianProfile,
  personalInfo,
  redirectedPath,
  getSSOURL,
  updateDoctorStatus,
  history,
  updateClinicianProfile,
}) => {
  const [ssoUrl, setSSOUrl] = useState();
  const [iframeLoading, setIFrameLoading] = useState(false);

  useEffect(() => {
    getSSOURL(personalInfo?.dosespot_id, data => {
      setIFrameLoading(true);
      setSSOUrl(data?.url);
    });
    //eslint-disable-next-line
  }, [personalInfo.dosespot_id]);

  return (
    <>
      <div
        className={classnames("pt-5 pl-3 pr-3")}
        style={{
          paddingBottom: 10,
        }}
      >
        <p className="onboarding-header m-0 pb-3">DoseSpot Profile</p>

        <p
          style={{
            textAlign: "justify",
          }}
        >
          DoseSpot is a method of sending electronic prescriptions in
          UrgiDoctor. It is an internet based, secure ePrescribing system.
          DoseSpot integrates with UrgiDoctor using a program link and offers
          two-way medication syncing.
        </p>

        {personalInfo?.dosespot_id && ssoUrl ? (
          <>
            {iframeLoading ? (
              <SpinnerBorder
                isCenter
                size="lg"
                style={{
                  color: "var(--secondary-color)",
                }}
              />
            ) : null}
            <>
              <div
                className="embed-responsive embed-responsive-16by9"
                style={{
                  height: "100vh",
                }}
              >
                <iframe
                  className="embed-responsive-item testsss"
                  src={ssoUrl}
                  title="SSO Login"
                  onLoad={() => setIFrameLoading(false)}
                ></iframe>
              </div>
              {/* <Button
                type="info"
                className={classnames("w-50 mx-auto my-5 content-center")}
                label={"Update DoseSpot Profile"}
                onClick={() =>
                  updateClinicianProfile(personalInfo?.dosespot_id)
                }
              /> */}
            </>
          </>
        ) : (
          <Row
            style={{
              paddingTop: "40vh",
            }}
          >
            <Button
              type="info"
              className={classnames("w-50 mx-auto my-5")}
              label={"Create DoseSpot Profile"}
              onClick={() => createClinicianProfile()}
            />
          </Row>
        )}

        {!redirectedPath && (
          <Row className="pb-3 float-right">
            <Button
              type="secondary"
              indicatorButton
              className={classnames("next-button")}
              label={<OnboardingIcon type="nextButton" />}
              disabled={!personalInfo.dosespot_id}
              onClick={() => {
                updateDoctorStatus(
                  {
                    denial_reason: null,
                    status: "PENDING",
                    block_reason: null,
                  },
                  () => {
                    updateUserData({
                      doctor_status: "PENDING",
                    });
                    localStorage.setItem("bankRedirect", false);
                    history.push(getOnboardingPath("/step5"));
                  }
                );
              }}
            />
          </Row>
        )}
      </div>
    </>
  );
};

const mapStoreToProps = ({ onboarding, auth }) => ({
  personalInfo: onboarding.personalInfo,
  redirectedPath: auth.redirectToOnboardingPath,
});

const mapDispatchToProps = dispatch => ({
  createClinicianProfile: () => dispatch(actions.createClinicianProfile()),
  getSSOURL: (userID, cb) => dispatch(actions.getSSOURL(userID, cb)),
  updateDoctorStatus: (payload, cb) =>
    dispatch(actions.updateDoctorStatus(payload, cb)),
  updateClinicianProfile: clinicianId =>
    dispatch(actions.updateClinicianProfile(clinicianId)),
});

export default withRouter(
  connect(mapStoreToProps, mapDispatchToProps)(DoseSpot)
);
